<!-- eslint-disable vue/require-v-for-key -->
<template>

  <header v-show="navmode.offcanv">
    <svg xmlns="http://www.w3.org/2000/svg" class="d-none">
      <symbol id="check2" viewBox="0 0 16 16">
        <path
          d="M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0z" />
      </symbol>
      <symbol id="circle-half" viewBox="0 0 16 16">
        <path d="M8 15A7 7 0 1 0 8 1v14zm0 1A8 8 0 1 1 8 0a8 8 0 0 1 0 16z" />
      </symbol>
      <symbol id="moon-stars-fill" viewBox="0 0 16 16">
        <path
          d="M6 .278a.768.768 0 0 1 .08.858 7.208 7.208 0 0 0-.878 3.46c0 4.021 3.278 7.277 7.318 7.277.527 0 1.04-.055 1.533-.16a.787.787 0 0 1 .81.316.733.733 0 0 1-.031.893A8.349 8.349 0 0 1 8.344 16C3.734 16 0 12.286 0 7.71 0 4.266 2.114 1.312 5.124.06A.752.752 0 0 1 6 .278z" />
        <path
          d="M10.794 3.148a.217.217 0 0 1 .412 0l.387 1.162c.173.518.579.924 1.097 1.097l1.162.387a.217.217 0 0 1 0 .412l-1.162.387a1.734 1.734 0 0 0-1.097 1.097l-.387 1.162a.217.217 0 0 1-.412 0l-.387-1.162A1.734 1.734 0 0 0 9.31 6.593l-1.162-.387a.217.217 0 0 1 0-.412l1.162-.387a1.734 1.734 0 0 0 1.097-1.097l.387-1.162zM13.863.099a.145.145 0 0 1 .274 0l.258.774c.115.346.386.617.732.732l.774.258a.145.145 0 0 1 0 .274l-.774.258a1.156 1.156 0 0 0-.732.732l-.258.774a.145.145 0 0 1-.274 0l-.258-.774a1.156 1.156 0 0 0-.732-.732l-.774-.258a.145.145 0 0 1 0-.274l.774-.258c.346-.115.617-.386.732-.732L13.863.1z" />
      </symbol>
      <symbol id="sun-fill" viewBox="0 0 16 16">
        <path
          d="M8 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8zM8 0a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-1 0v-2A.5.5 0 0 1 8 0zm0 13a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-1 0v-2A.5.5 0 0 1 8 13zm8-5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1 0-1h2a.5.5 0 0 1 .5.5zM3 8a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1 0-1h2A.5.5 0 0 1 3 8zm10.657-5.657a.5.5 0 0 1 0 .707l-1.414 1.415a.5.5 0 1 1-.707-.708l1.414-1.414a.5.5 0 0 1 .707 0zm-9.193 9.193a.5.5 0 0 1 0 .707L3.05 13.657a.5.5 0 0 1-.707-.707l1.414-1.414a.5.5 0 0 1 .707 0zm9.193 2.121a.5.5 0 0 1-.707 0l-1.414-1.414a.5.5 0 0 1 .707-.707l1.414 1.414a.5.5 0 0 1 0 .707zM4.464 4.465a.5.5 0 0 1-.707 0L2.343 3.05a.5.5 0 1 1 .707-.707l1.414 1.414a.5.5 0 0 1 0 .708z" />
      </symbol>
      <symbol id="house-fill" viewBox="0 0 16 16">
        <path
          d="M8.707 1.5a1 1 0 0 0-1.414 0L.646 8.146a.5.5 0 0 0 .708.708L8 2.207l6.646 6.647a.5.5 0 0 0 .708-.708L13 5.793V2.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1.293L8.707 1.5Z" />
        <path d="m8 3.293 6 6V13.5a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 2 13.5V9.293l6-6Z" />
      </symbol>
      <symbol id="file-earmark" viewBox="0 0 16 16">
        <path
          d="M14 4.5V14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h5.5L14 4.5zm-3 0A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V4.5h-2z" />
      </symbol>
      <symbol id="bootstrap" viewBox="0 0 118 94">
        <title>Bootstrap</title>
        <path fill-rule="evenodd" clip-rule="evenodd"
          d="M24.509 0c-6.733 0-11.715 5.893-11.492 12.284.214 6.14-.064 14.092-2.066 20.577C8.943 39.365 5.547 43.485 0 44.014v5.972c5.547.529 8.943 4.649 10.951 11.153 2.002 6.485 2.28 14.437 2.066 20.577C12.794 88.106 17.776 94 24.51 94H93.5c6.733 0 11.714-5.893 11.491-12.284-.214-6.14.064-14.092 2.066-20.577 2.009-6.504 5.396-10.624 10.943-11.153v-5.972c-5.547-.529-8.934-4.649-10.943-11.153-2.002-6.484-2.28-14.437-2.066-20.577C105.214 5.894 100.233 0 93.5 0H24.508zM80 57.863C80 66.663 73.436 72 62.543 72H44a2 2 0 01-2-2V24a2 2 0 012-2h18.437c9.083 0 15.044 4.92 15.044 12.474 0 5.302-4.01 10.049-9.119 10.88v.277C75.317 46.394 80 51.21 80 57.863zM60.521 28.34H49.948v14.934h8.905c6.884 0 10.68-2.772 10.68-7.727 0-4.643-3.264-7.207-9.012-7.207zM49.948 49.2v16.458H60.91c7.167 0 10.964-2.876 10.964-8.281 0-5.406-3.903-8.178-11.425-8.178H49.948z">
        </path>
      </symbol>
      <symbol id="home" viewBox="0 0 16 16">
        <path
          d="M8.354 1.146a.5.5 0 0 0-.708 0l-6 6A.5.5 0 0 0 1.5 7.5v7a.5.5 0 0 0 .5.5h4.5a.5.5 0 0 0 .5-.5v-4h2v4a.5.5 0 0 0 .5.5H14a.5.5 0 0 0 .5-.5v-7a.5.5 0 0 0-.146-.354L13 5.793V2.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1.293L8.354 1.146zM2.5 14V7.707l5.5-5.5 5.5 5.5V14H10v-4a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5v4H2.5z" />
      </symbol>
      <symbol id="speedometer2" viewBox="0 0 16 16">
        <path
          d="M8 4a.5.5 0 0 1 .5.5V6a.5.5 0 0 1-1 0V4.5A.5.5 0 0 1 8 4zM3.732 5.732a.5.5 0 0 1 .707 0l.915.914a.5.5 0 1 1-.708.708l-.914-.915a.5.5 0 0 1 0-.707zM2 10a.5.5 0 0 1 .5-.5h1.586a.5.5 0 0 1 0 1H2.5A.5.5 0 0 1 2 10zm9.5 0a.5.5 0 0 1 .5-.5h1.5a.5.5 0 0 1 0 1H12a.5.5 0 0 1-.5-.5zm.754-4.246a.389.389 0 0 0-.527-.02L7.547 9.31a.91.91 0 1 0 1.302 1.258l3.434-4.297a.389.389 0 0 0-.029-.518z" />
        <path fill-rule="evenodd"
          d="M0 10a8 8 0 1 1 15.547 2.661c-.442 1.253-1.845 1.602-2.932 1.25C11.309 13.488 9.475 13 8 13c-1.474 0-3.31.488-4.615.911-1.087.352-2.49.003-2.932-1.25A7.988 7.988 0 0 1 0 10zm8-7a7 7 0 0 0-6.603 9.329c.203.575.923.876 1.68.63C4.397 12.533 6.358 12 8 12s3.604.532 4.923.96c.757.245 1.477-.056 1.68-.631A7 7 0 0 0 8 3z" />
      </symbol>
      <symbol id="table" viewBox="0 0 16 16">
        <path
          d="M0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2zm15 2h-4v3h4V4zm0 4h-4v3h4V8zm0 4h-4v3h3a1 1 0 0 0 1-1v-2zm-5 3v-3H6v3h4zm-5 0v-3H1v2a1 1 0 0 0 1 1h3zm-4-4h4V8H1v3zm0-4h4V4H1v3zm5-3v3h4V4H6zm4 4H6v3h4V8z" />
      </symbol>
      <symbol id="people-circle" viewBox="0 0 16 16">
        <path d="M11 6a3 3 0 1 1-6 0 3 3 0 0 1 6 0z" />
        <path fill-rule="evenodd"
          d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8zm8-7a7 7 0 0 0-5.468 11.37C3.242 11.226 4.805 10 8 10s4.757 1.225 5.468 2.37A7 7 0 0 0 8 1z" />
      </symbol>
      <symbol id="grid" viewBox="0 0 16 16">
        <path
          d="M1 2.5A1.5 1.5 0 0 1 2.5 1h3A1.5 1.5 0 0 1 7 2.5v3A1.5 1.5 0 0 1 5.5 7h-3A1.5 1.5 0 0 1 1 5.5v-3zM2.5 2a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5h-3zm6.5.5A1.5 1.5 0 0 1 10.5 1h3A1.5 1.5 0 0 1 15 2.5v3A1.5 1.5 0 0 1 13.5 7h-3A1.5 1.5 0 0 1 9 5.5v-3zm1.5-.5a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5h-3zM1 10.5A1.5 1.5 0 0 1 2.5 9h3A1.5 1.5 0 0 1 7 10.5v3A1.5 1.5 0 0 1 5.5 15h-3A1.5 1.5 0 0 1 1 13.5v-3zm1.5-.5a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5h-3zm6.5.5A1.5 1.5 0 0 1 10.5 9h3a1.5 1.5 0 0 1 1.5 1.5v3a1.5 1.5 0 0 1-1.5 1.5h-3A1.5 1.5 0 0 1 9 13.5v-3zm1.5-.5a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5h-3z" />
      </symbol>
    </svg>

    <div class="wrapper">
      <nav v-show="!hidenav" class="navbar bg-body-tertiary" aria-label="Light offcanvas navbar">
        <div class="container-fluid">
          <a class="navbar-brand" href="#">Thing Explorer</a>
          <button class="navbar-toggler" type="button" ref="closeButton" data-bs-toggle="offcanvas"
            data-bs-target="#offcanvasNavbarLight" aria-controls="offcanvasNavbarLight" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
          </button>
          <div class="offcanvas offcanvas-end" ref="offCanvas" tabindex="-1" id="offcanvasNavbarLight"
            aria-labelledby="offcanvasNavbarLightLabel">
            <div class="offcanvas-header">
              <h5 class="offcanvas-title" id="offcanvasNavbarLightLabel">Thing Explorer</h5>
              <button type="button" class="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button>
            </div>
            <div class="offcanvas-body">
              <ul class="navbar-nav ">
                <li v-if="false">
                  <router-link to="/" @click.prevent="closeOffCanvas()">
                    <svg class="iconmark  pe-none me-2" width="16" height="16">
                      <use xlink:href="#house-fill" />
                    </svg>Home</router-link>
                </li>
                <li v-if="false">
                  <router-link to="/about" @click.prevent="closeOffCanvas()">
                    <svg class="iconmark  pe-none me-2" width="16" height="16">
                      <use xlink:href="#sun-fill" />
                    </svg>About
                  </router-link>
                </li>



                <li v-if="false">
                  <router-link to="/examp" @click.prevent="closeOffCanvas()">
                    <svg class="iconmark  pe-none me-2" width="16" height="16">
                      <use xlink:href="#check2" />
                    </svg>Example
                  </router-link>
                </li>

                <li v-if="false">
                  <router-link to="/commerce" @click.prevent="closeOffCanvas()">
                    <svg class="iconmark  pe-none me-2" width="16" height="16">
                      <use xlink:href="#check2" />
                    </svg>Commerce
                  </router-link>
                </li>
                <li>
                  <router-link to="/profile?lout=false" @click.prevent="closeOffCanvas()" v-show="!cnav.identified">
                    <svg class="bi pe-none me-2" width="16" height="16">
                      <use xlink:href="#circle-half" />
                    </svg>Log in
                  </router-link>
                </li>
                <li>
                  <router-link to="/profile?lout=true" @click.prevent="closeOffCanvas()" v-show="cnav.identified">
                    <svg class="bi pe-none me-2" width="16" height="16">
                      <use xlink:href="#circle-half" />
                    </svg>Log out
                  </router-link>
                </li>
                <li v-if="false">
                  <router-link to="/welcome" @click.prevent="closeOffCanvas()">
                    <svg class="bi pe-none me-2" width="16" height="16">
                      <use xlink:href="#moon-stars-fill" />
                    </svg>Welcome
                  </router-link>
                </li>
                <li>
                  <router-link to="/chives" @click.prevent="closeOffCanvas()">
                    <svg class="bi pe-none me-2" width="16" height="16">
                      <use xlink:href="#check2" />
                    </svg>Choose Things
                  </router-link>
                </li>
                <li>
                  <router-link to="/things" @click.prevent="closeOffCanvas()">
                    <svg class="bi pe-none me-2" width="16" height="16">
                      <use xlink:href="#check2" />
                    </svg>Things
                  </router-link>
                </li>

                <li v-if="devmode.dev">
                  <router-link to="/simul2" @click.prevent="closeOffCanvas()">
                    <svg class="bi pe-none me-2" width="16" height="16">
                      <use xlink:href="#check2" />
                    </svg>Simulation
                  </router-link>
                </li>

                <li v-if="false">
                  <router-link to="/employes" @click.prevent="closeOffCanvas()">
                    <svg class="bi pe-none me-2" width="16" height="16">
                      <use xlink:href="#check2" />
                    </svg>Employees
                  </router-link>
                </li>
                <li v-if="false">
                  <router-link to="/bootstrapt" @click.prevent="closeOffCanvas()">
                    <svg class="bi pe-none me-2" width="16" height="16">
                      <use xlink:href="#check2" />
                    </svg>Bootstrap t
                  </router-link>
                </li>
                <li v-if="false">
                  <router-link to="/bootstrap" @click.prevent="closeOffCanvas()">
                    <svg class="bi pe-none me-2" width="16" height="16">
                      <use xlink:href="#check2" />
                    </svg>Bootstrap
                  </router-link>
                </li>
                <li v-if="false">
                  <router-link to="/bootstrapdb" @click.prevent="closeOffCanvas()">
                    <svg class="bi pe-none me-2" width="16" height="16">
                      <use xlink:href="#check2" />
                    </svg>Bootstrap dashboard
                  </router-link>
                </li>

                <li v-if="false">
                  <router-link to="/bapp" @click.prevent="closeOffCanvas()">
                    <svg class="bi pe-none me-2" width="16" height="16">
                      <use xlink:href="#check2" />
                    </svg>Bootstrap app
                  </router-link>
                </li>
                <li v-if="false">
                  <router-link to="/qrc?id=38CFE7" @click.prevent="closeOffCanvas()">
                    <svg class="bi pe-none me-2" width="16" height="16">
                      <use xlink:href="#check2" />
                    </svg>QrCode 38CFE7
                  </router-link>
                </li>
              </ul>
              <form v-if="false" class="d-flex mt-3" role="search">
                <input class="form-control me-2" type="search" placeholder="Search" aria-label="Search">
                <button class="btn btn-outline-success" type="submit">Search</button>
              </form>

              <form v-if="true" class="d-flex mt-3" role="search">

                <div class="custom-control custom-checkbox">
                  <input type="checkbox" class="custom-control-input" id="jgr678" @click="devMode"
                    v-model="devmode.dev">
                  <label class="custom-control-label" for="jgr678">&nbsp; dev mode</label>
                </div>

              </form>

            </div>
          </div>
        </div>
        <div v-show="cuser.login === ADMIN_AGENT">
          <div class="custom-control custom-checkbox">
            <input type="checkbox" class="custom-control-input" id="atm" v-model="autoprogress.mode">
            <label class="custom-control-label" for="atm">&nbsp; auto mode </label>
          </div>

          <div class="custom-control custom-checkbox">
            <input type="checkbox" class="custom-control-input" id="atm7654" v-model="sho.chartlog">
            <label class="custom-control-label" for="atm7654">&nbsp; show config</label>
          </div>

          <div class="custom-control custom-checkbox">
            <input type="checkbox" class="custom-control-input" id="atm4324" @click="shoclick" v-model="sholines">
            <label class="custom-control-label" for="atm4324">&nbsp; show logs</label>
          </div>

          <div class="custom-control custom-checkbox">
            <input type="checkbox" class="custom-control-input" id="atm6424" @click="chmenu" v-model="navmode.offcanv">
            <label class="custom-control-label" for="atm6424">&nbsp; change menu</label>
          </div>


        </div>
      </nav>
    </div>
  </header>

  <nav v-show="!navmode.mini && !hidenav && !navmode.offcanv">
    <router-link to="/h">Home a</router-link> |
    <router-link to="/">Home b</router-link> |
    <router-link to="/about">About</router-link> |
    <router-link to="/welcome">Welcome</router-link> |
    <router-link to="/serial">Serial</router-link> |



    <router-link to="/filedl" >
      <svg class="iconmark  pe-none me-2" width="16" height="16">
        <use xlink:href="#check2" />
      </svg>File Dl example
    </router-link> |


    <router-link to="/thing3">Eval Composable</router-link> |
    <router-link to="/data">Data</router-link> |

    <router-link to="/scatter">Scatter</router-link> |
    <router-link to="/chart">Chart</router-link> |
    <router-link to="/chartws">ChartWS</router-link> |
    <router-link to="/trendline">Trendline</router-link> |
    <router-link to="/line">Line</router-link> |
    <router-link to="/calc">Calc</router-link> |
    <router-link to="/interpolation">Interpolation v1</router-link> |
    <router-link to="/interp">Interpolation v2</router-link> |
    <router-link to="/interpol">Interpolation v3</router-link> |
    <router-link to="/interpol4">Interpolation v4</router-link> |
    <router-link to="/interpol5">Interpolation v5</router-link> |
    <router-link to="/interpol6">Interpolation v6</router-link> |
    <router-link to="/matrix">Matrix</router-link> |
    <router-link to="/employees">Employees</router-link> |


    <router-link to="/commerce">Commerce</router-link> |
    <router-link to="/simple">Simple Chat</router-link> |
    <router-link to="/datach">Data Chat</router-link> |
    <router-link to="/accessu">Raw Chat</router-link> |
    <router-link to="/stompchat">Stomp Chat</router-link> |
    <router-link to="/socketv">Socket View</router-link> |
    <router-link to="/ortho">Ortho</router-link> |
    <router-link to="/bootstrapf">Bootstrap f</router-link> |
    <router-link to="/bootstrapt">Bootstrap t</router-link> |
    <router-link to="/bootstrap">Bootstrap</router-link> |
    <router-link to="/draw3">Draw</router-link> |
    <router-link to="/ptnt">Ptnt</router-link> |
    <router-link to="/demomime">Demo Mime</router-link> |



    <router-link v-show="!cnav.identified" to="/profile?lout=false">Log in</router-link>
    <router-link v-show="cnav.identified" to="/profile?lout=true">Log out</router-link> |
    <router-link to="/chives">Choose Things</router-link> |
    <router-link to="/results">Results</router-link> |
    <router-link to="/sdata">SData</router-link> |
    <router-link to="/things">Things</router-link> |
    <router-link to="/simul2">Simulation2</router-link> |
    <router-link to="/hdcorrec">Hivedata Correction</router-link> |
    <router-link to="/devicedata">DeviceData</router-link> |
    <router-link to="/dscalec">Correction Scale Data</router-link> |

    <router-link to="/thing2">Thing 2</router-link> |
    <router-link to="/hivedata">HiveData</router-link> |
    <router-link to="/correc3">Correction</router-link> |
    <router-link to="/populated">Populated</router-link> |
    <router-link to="/mycommands">Commands</router-link> |
    <!--<router-link to="/agents">Agents</router-link> |-->
    <router-link to="/thview">Agents</router-link> |
    <router-link to="/sites">Sites</router-link> |
    <!-- 
    <router-link to="/allth_ings">All Things</router-link> |
    -->
    
    <router-link to="/cache">Cache</router-link> |
    <router-link to="/examp">Example</router-link>


    <div class="custom-control custom-checkbox">
      <input type="checkbox" class="custom-control-input" id="atm" v-model="autoprogress.mode">
      <label class="custom-control-label" for="atm">&nbsp; auto mode </label>
    </div>

    <div class="custom-control custom-checkbox">
      <input type="checkbox" class="custom-control-input" id="atm7654" v-model="sho.chartlog">
      <label class="custom-control-label" for="atm7654">&nbsp; show config</label>
    </div>

    <div class="custom-control custom-checkbox">
      <input type="checkbox" class="custom-control-input" id="atm4324" @click="shoclick" v-model="sholines">
      <label class="custom-control-label" for="atm4324">&nbsp; show logs</label>
    </div>

    <div class="custom-control custom-checkbox">
      <input type="checkbox" class="custom-control-input" id="atm6424" @click="chmenu" v-model="navmode.offcanv">
      <label class="custom-control-label" for="atm6424">&nbsp; change menu</label>
    </div>

  </nav>

  <nav v-show="navmode.mini && !hidenav && !navmode.offcanv"> <!--modify also router  /dscale root-->
    <router-link to="/profile">Login</router-link> |
    <router-link to="/chives">Choose Things</router-link>
  </nav>

  <ws-connect742 ref="pconnect" @onConnected="setConnected" @onJoined="setJoined_" @onMessage="recordMessage"
    @onWsError="setWsError" />


  <RouterView />
  <!--
    <router-link to="/markerexample">Marker</router-link> |
    <router-link to="/leafletexample">Leaflet</router-link> |
    <router-link to="/mapexample">Map</router-link> |
    <router-link to="/calendarexample">Calendar</router-link> |

-->

  <div class="col-11">

    <div class="text-left" v-show="sholines">
      <h5>Logs</h5>
      <div class="table-responsive text-left">
        <table class="table table-hover table-fixed">
          <thead>
            <tr>
              <th>Content</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="lin in lines">
              <td>
                {{ lin }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="text-left" v-show="joined && recordMessages">
      <h5>App Messages</h5>
      <div class="table-responsive text-left">
        <table class="table table-hover table-fixed">
          <thead>
            <tr>
              <th>Id</th>
              <th>From</th>
              <th>Content</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="message in wsmesgs" :key="message.id">
              <td>
                {{ message.id }}
              </td>
              <td>
                {{ message.from }}
              </td>
              <td>
                {{ fmesg(message) }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="text-left" v-show="recordLogs">
      <h5>App Logs</h5>
      <div class="table-responsive text-left">
        <table class="table table-hover table-fixed">
          <thead>
            <tr>
              <th>Id</th>
              <th>From</th>
              <th>Content</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="message in wslogs" :key="message.id">
              <td>
                {{ message.id }}
              </td>
              <td>
                {{ message.from }}
              </td>
              <td>
                {{ fmesg(message) }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>




  <!--
  <div>
    {{ lines }}
  </div>
-->
  <Footer />
</template>

<script setup lang="ts">
import { RouterLink, RouterView } from 'vue-router'
import { isTablet } from "mobile-device-detect";
import { navmode, autoprogress, cuser, devmode } from '@/store/store';
import moment from "moment";

import { ref, onMounted, watch, nextTick, onUnmounted } from 'vue'

import type { Quad } from '@/types/quad'
import type { CustomDetail, CustomDetailText } from './types/backendevent'

import { bMessage, bResponse, wdim, host, sho } from './store/store';
import { PORT, PORT_GTW } from '@/pshared/common';
import type { WSMessage } from './types/wsmessage';
import router from './router';
import { CONNECTION_KEY, PTN_APP_KEY } from './pshared/constants';
import { cnav } from "@/store/store";

import WsConnect742 from '@/components/communication/WsConnect742.vue'

import Footer from '@/components/app/AppFooter.vue'
//import { PROD_65_3 } from './api/constants';

import dayjs from "dayjs";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";
import locale_fr from "dayjs/locale/fr";
import { useDbCache } from './composables/useDbCache';
import { ADMIN_AGENT } from "@/api/constants";

const pconnect = ref()


const SIMUL_DIRECT_NAV_AVAILABLE_nu = 'simul2' //allow direct navigation w browser

//export 
const GATEWAY_SENDER = "wsgateway";
let cntr = 0;
const CONNECT_DELAY = 1000


const LOG_APP = true

const wsmesgs = ref<WSMessage[]>([]);
const wslogs = ref<WSMessage[]>([]);
//const wserr = ref("");
const joined = ref(false);
const recordMessages = ref(false);
const recordLogs = ref(false);
const sholines = ref(false);
//const devmod = ref(false);
const hidenav = ref(false)

const lines = ref<string[]>([])
const connected = ref(false)



//let ws: any = undefined
//let wurl4 = ''

let wsError = false;
let closing = false;
let cback: any = undefined;


const randomInt = (min: number, max: number) =>
  Math.floor(Math.random() * (max - min + 1)) + min;

const windowHeight = ref(0); // window.innerHeight,
const windowWidth = ref(0); //: window.innerWidth,
const windowX = ref(0); //window.scrollX,
const windowY = ref(0); //: window.scrollY,
const dtype = ref("");

const closeButton = ref()

const TESTDATA = false;

let wlhost = ''
let hprot = ''


const SHO_CHECKBOX = ref(false)


//const  {cacheService,cdbf} = useDbCache() //TODO create plugin

function closeOffCanvas() {
  closeButton.value.click()
}


function fmesg(message: WSMessage) {
  if (message.extra) {
    if (message.from == GATEWAY_SENDER) {
      return message.extra.substring(39);
    } else {
      return message.extra;
    }
  }
}

function initData_nu() {
  if (!TESTDATA) {
    // requestFoobar_nu();
  }
}

function initDataz_nu() {
  // bridge = new BridgeSender(undefined);
  setTimeout(() => {
    initData_nu();
  }, 8);

  //TODO keep extern socket communication
}

function setJoined_(j: boolean) {
  joined.value = j;
  if (joined.value) {
    setTimeout(() => {
      initDataz_nu();
    }, 500);
  }
}

function setConnected(connectd: boolean) {
  connected.value = connectd
}


function recordMessage(wm: WSMessage) {
  wm.id = cntr++
  wsmesgs.value.push(wm);
}


function setWsError(value: boolean) {
  wsError = value
}

/*
{
  "type": "List",
  "data": "d90_8_798_klkgr_ht875",
  "clazz": "DeviceData[]",
  "key": null,
  "recipient": null,
  "sender": null,
  "value": [
    {
      "id": 355743,
      "time": "2024-04-15T11:51:49.123325900Z",
      "ownerId": "24",
      "deviceId": "N_0DC40A24",
      "deviceType": 2,
      "annotation": "",
      "dataName": "weight",
      "attachment": "",
      "nature": "iot",
      "hvalue": -0.172
    }
  ]
}


function receiveStand_ardMessages(message: string): boolean {
  try {
    const r: CustomDetail = JSON.parse(message)
    Object.assign(bR_esponse, r)
    //bRe_sponse=r

    if (recordMessages.value)
      recordMessage(message);
    return true
  } catch (error) {
    console.log(`in receiveStand_ardMessages error ${error} in [${message}]`)
  }
  return false
}
*/


let lincnt = 0
//before change notify mechanism



function shoclick() {
  lines.value.splice(0, lines.value.length)
}

function devMode() {
  if (devmode.dev == true) {
    console.log('dev mode');
  } else {
    console.log('prod mode');
    // devmod_e.dev = devmod.value;
  }
  // console.log(`############   dev mode ${devmod.value}`);
  // lines.value.splice(0, lines.value.length)
}

function chmenu() {
  navmode.offcanv = !navmode.offcanv
}


watch(bResponse, (response_) => {
  if (LOG_APP && sholines.value) {
    try {
      const m: CustomDetail = response_
      lines.value.push(`${lincnt++} | bresponse received ${JSON.stringify(m)}`)
    } catch (error) {
      lines.value.push(`${lincnt++} | bresponse error ${error}`)
    }
  }
})

watch(bMessage, (message) => {
  try {
    //debugger
    const m: CustomDetail = message
    if (m.data) {
      if (m.data == 'send_quadratic') {
        const quad: Quad = m.value
        const data = JSON.stringify(quad)
        //send raw data, should not happen
        pconnect.value.sendm(data)
      } else if (m.data == 'hide_menu') {
        hidenav.value = true
      } else if (m.data == 'show_menu') {
        hidenav.value = false
      }
    } else {
      const data = JSON.stringify(m)
      pconnect.value.sendm(data)
    }
  } catch (error) {
    lines.value.push(`bMessage error ${error}`)
  }
})


function setupHost() {
  console.log('setup host')
  //deb_ugger
  wlhost = window.location.hostname
  console.log(`window.location.hostname=${wlhost}`)
  hprot = window.location.protocol
  console.log(`window.location.protocol=${hprot}`)
  if (hprot === 'https:') {
    host.base = `https://${wlhost}`
    host.ws = `wss://${wlhost}`
  } else { // if (hprot === 'http:') 
    host.base = `http://${wlhost}:${PORT}`
    host.ws = `ws://${wlhost}:${PORT}`
  };
  host.api = `${host.base}/api`

  //host.api = `http://${window.location.hostname}:${PORT}/api`
  host.base_gtw = `http://${wlhost}:${PORT_GTW}`
  host.api_gtw = `http://${wlhost}:${PORT_GTW}/api`
  setTimeout(() => {
    pconnect.value.open()
  }, CONNECT_DELAY);
}

function close() {
  pconnect.value.close()
  console.log(`ws disconnecting `)
}


function getViewport() {
  // https://stackoverflow.com/a/8876069
  const width = Math.max(
    document.documentElement.clientWidth,
    window.innerWidth || 0
  );
  if (width <= 576) return "xs";
  if (width <= 768) return "sm";
  if (width <= 992) return "md";
  if (width <= 1200) return "lg";
  return "xl";
}

function getDimension() {
  windowHeight.value = window.innerHeight;
  windowWidth.value = window.innerWidth;
  windowX.value = window.scrollX;
  windowY.value = window.scrollY;
  let viewport = getViewport();
  wdim.height = windowHeight.value;
  wdim.width = windowWidth.value;
  wdim.x = windowX.value;
  wdim.y = windowY.value;
  wdim.viewport = viewport;
  wdim.device = dtype.value;
  // };
  //EventBus.$emit("dimevent", msg);
}
function onResize() {
  getDimension();
}

function onScroll() {
  getDimension();
}


function identify(myid: string, gth: boolean) {
  let tip = "ConnectionStatus";
  let status = pconnect.value.identify(myid)
  if (cback)
    cback({ id: tip, val: status });
  console.log(`####### identification id=${myid}`);
  if (gth) {
    goh()
  }
  //showled_tempo(1, true, 500);
}

function goto(path: string) {
  router.push({ path: path });//, query: { id: thingName }
}

function goh() {
  goto('h')
}


const navlang = ref("");
const tz = ref("");
const djl = ref("");
const djz = ref("");



function getNavigatorLanguage() {
  if (navigator.languages && navigator.languages.length) {
    return navigator.languages[0];
  } else {
    return navigator.language;
  }
}


function mntedLocale() {
  navlang.value = getNavigatorLanguage();
  dayjs.locale(locale_fr);
  tz.value = Intl.DateTimeFormat().resolvedOptions().timeZone;
  djl.value = dayjs.locale();
  dayjs.extend(utc);
  dayjs.extend(timezone);
  djz.value = dayjs.tz.guess();
}


onMounted(() => {
  //deb_ugger
  console.log('APP mounted')

  mntedLocale();
  //SHO_CHECKBOX.value = !PROD_6_53
  sessionStorage.setItem("current_user", '{ "id": -1}');
  sessionStorage.setItem("current_ptn_model", "0014");
  sessionStorage.setItem(CONNECTION_KEY, "UNKNOWN");

  setupHost()

  nextTick().then(() => {
    window.addEventListener("resize", onResize);
    window.addEventListener("scroll", onScroll);
    dtype.value = isTablet ? "tablet" : "notablet";
  });

  nextTick().then(() => {
    // dtype.value = isTablet ? "tablet" : "notablet";
    // EventBus.$on("wschangepage", this.changePage);
    // startWs();
    setTimeout(function () {
      const tk = moment().valueOf() - 1702890517314;
      const rk = randomInt(0, 100);
      const goh = true;//! (cnav.to == SIMUL_DIRECT_NAV_AVAILABLE) //navigate direct
      identify(`${PTN_APP_KEY}_${rk}_${tk}`, goh);
    }, CONNECT_DELAY * 2); //wait until ws is connected
  });


  nextTick().then(() => {
    if (navmode.mini) {
      setTimeout(function () {
        router.push({ path: '/profile' });
      }, 510); //wait until ws is connected
    }
  });

})

onUnmounted(() => {

  window.removeEventListener("resize", onResize);
  window.removeEventListener("scroll", onScroll);

  close();
  pconnect.value.quit()
  console.log("App stopped");
});

//todo integr base frontend w templates
</script>

<style lang="scss">
.v-enter-active,
.v-leave-active {
  transition: opacity 2s ease;
}

.v-enter-from,
.v-leave-to {
  opacity: 0;
}



#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

nav {
  text-align: center;
  color: #2c3e50;
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}

.container {
  max-width: 960px;
}

.border-top {
  border-top: 1px solid #e5e5e5;
}

.border-bottom {
  border-bottom: 1px solid #e5e5e5;
}

.border-top-gray {
  border-top-color: #adb5bd;
}

.box-shadow {
  box-shadow: 0 .25rem .75rem rgba(0, 0, 0, .05);
}

.lh-condensed {
  line-height: 1.25;
}


div.spacer50 {
  font-size: 0;
  height: 50px;
  line-height: 0;
}

div.spacer10 {
  font-size: 0;
  height: 10px;
  line-height: 0;
}

div.spacer20 {
  font-size: 0;
  height: 20px;
  line-height: 0;
}


div.spacer30 {
  font-size: 0;
  height: 30px;
  line-height: 0;
}

div.spacer4 {
  font-size: 0;
  height: 4px;
  line-height: 0;
}
</style>
